// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OtiA","colBig":"styles_colBig__K-8Mj","colSmall":"styles_colSmall__1WuQs"};